import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=9d396b02&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=javascript&"
export * from "./Edit.vue?vue&type=script&lang=javascript&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=9d396b02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d396b02",
  null
  
)

export default component.exports